<template>
  <div>

    <c-title>Bewertungen zu Ihrem Projekt</c-title>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <div v-else>

      <c-project-summary
        :abstract="project.abstract"
        :description="project.description"
        :title="project.title"
        :image="project.image ? $config.appUrl + project.image : ''"
      />

      <c-title tag="h2">Bewertungsliste</c-title>

      <p v-if="!ratings.length">Für dieses Projekt wurden noch keine Bewertungen abgegeben.</p>
      <p v-if="project.rating_code && project.status === 'Projektvorschlag eingereicht'">Geben Sie den Code <strong>{{ project.rating_code }}</strong> weiter, damit andere Ihr Projekt bewerten und kommentieren können.</p>

      <c-card
        v-for="rating in ratings"
        :key="rating.identifier"
      >
        <c-rating
          :comment="rating.comment"
          :date="new Date(rating.last_edit)"
          :rating="rating.rating"
          show-time
        />
      </c-card>

    </div>

  </div>
</template>

<script>
import CBusy from '@/components/CBusy'
import CCard from '@/components/CCard'
import CProjectSummary from '@/components/project/CProjectSummary'
import CRating from '@/components/CRating'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VProjectRatingList',

  components: {
    CBusy,
    CCard,
    CProjectSummary,
    CRating,
    CTitle
  },

  props: {
    identifier: {
      type: String
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      project: null,
      ratings: []
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('projects/project/', {
      params: { identifier: this.identifier }
    })
      .then(response => {
        this.project = response.data.project
        return this.$api.get('projects/rating/', {
          params: { identifier: this.identifier }
        })
      })
      .then(response => {
        this.ratings = this.ratings.concat(this.ratings, response.data)
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          fallback: 'Ihre Projektbewertungen können zurzeit leider nicht geladen werden. Bitte versuchen Sie es später erneut.'
        })

        this.$router.push({ name: 'dashboard' })
      })
  }
}
</script>
